import React from "react";
import styled from 'styled-components'
import ApiSubscriber from 'models/data/api/ApiSubscriber'
import ShareLinkButtons from "components/shared/buttons/ShareLinkButtons";
import CopyLinkField from "components/shared/form_fields/CopyLinkField";
import NewsletterReferralStatusQuery from './NewsletterReferralStatusQuery'
import { isNil } from 'lodash'
import { baseUrl } from 'services/shared/Environment'

const Container = styled.div`
    max-width:500px;
`

const Text = styled.p.attrs({
	className: "text-lg my-4 text-center"
})`
	font-family: ${props => props.theme.fonts.poppins};
`;

const WarningText = styled<any>(Text)`
	color: ${props => props.theme.colors.orange};
`;

const Title = styled.h2.attrs({
	className: "text-2xl mb-4 text-center font-bold"
})`
	font-family: ${props => props.theme.fonts.poppins};
`;


const CopyReferralLinkButtons = ({ link }) => (
	<>
		<Title>
			Refer the Juggernaut Weekly, <br />
			get some swag
		</Title>
		<ShareLinkButtons link={link} />
		<b className="mt-2 mb-0">
			<Text>Your newsletter referral link</Text>
		</b>
		<CopyLinkField link={link} />
	</>
);

const RewardContainer = styled.div.attrs({
	className: "flex flex-col items-center justify-center rounded-lg p-2"
})`
	color: black;
`;

const RewardTitle = styled.p.attrs({
	className: "mx-2 font-bold"
})`
	font-family: ${props => props.theme.fonts.poppins};
`;

const RewardName = styled.p.attrs({
	className: "mx-2 text-center"
})`
	font-family: ${props => props.theme.fonts.poppins};
`;

const Reward = ({ name, number }) => (
	<RewardContainer>
		<RewardTitle>@ {number} Referrals</RewardTitle>
		<RewardName>{name}</RewardName>
	</RewardContainer>
);

export default ({ email }) => {

    const subscriberReferralCode = subscriber => ApiSubscriber.referralLink(subscriber);

    const subscriberReferralLink = subscriber => {
        return `${baseUrl()}/newsletter?r=${subscriberReferralCode(subscriber)}`;
    }

    const numSubscriberReferrals = subscriber => ApiSubscriber.numReferred(subscriber)

    return (
		<NewsletterReferralStatusQuery email={email}>
			{({ subscriber }) => (
				<div className="w-full flex flex-col items-center p-10">
					<Container>
						<CopyReferralLinkButtons link={subscriberReferralLink(subscriber)} />
						<WarningText>
							You've made {numSubscriberReferrals(subscriber)} {numSubscriberReferrals(subscriber) === 1 ? 'referral' : 'referrals'}.
						</WarningText>
						<div className="flex flex-col items-center justify-center my-5">
							<Reward number={3} name={"Juggernaut stickers"} />
							<Reward number={5} name={"Exclusive community invite"} />
							<Reward number={10} name={"1 mo. free paid access"} />
							<Reward number={15} name={"Juggernaut chai mug"} />
							<Reward number={25} name={"Juggernaut soft t-shirt"} />
							<Reward number={50} name={"Juggernaut Moleskine notebook"} />
							<Reward number={75} name={"Limited edition Juggernaut tote"} />
							<Reward number={100} name={"1 yr. free paid access"} />
						</div>
					</Container>
				</div>
			)}
		</NewsletterReferralStatusQuery>
	);
}
